import React from 'react'
import {Row, Col} from 'react-bootstrap'
import {StaticImage} from 'gatsby-plugin-image'

import Section from '../../components/Section'
import TextInCircle from '../../components/TextInCircle'
import ImageWithText from '../../components/ImageWithText'

import ScarIcon from './img/scar.inline.svg'
import PlaneIcon from './img/airplane.inline.svg'
import CalendarIcon from './img/calendar.inline.svg'

const LastingImpact: React.FC = () => {
  const getSvgIcon = (name: string) => {
    if (name === 'scar') return <ScarIcon className="p-3 p-md-1 p-lg-0" />
    if (name === 'plane') return <PlaneIcon className="p-3 p-md-1 p-lg-0" />
    if (name === 'calendar')
      return <CalendarIcon className="p-3 p-md-1 p-lg-0" />
    return null
  }

  return (
    <Section
      id="lasting-impact"
      background="gray"
      className="text-center text-xl-end"
    >
      <Row className="gx-xl-5">
        <Col xl={7} className="mb-5 mb-lg-0 order-xl-2 ps-xl-5">
          <p className="fs-3 fw-bold">
            Although most children recover well from chickenpox, there can be
            further complications and consequences:
          </p>

          <Row className="py-4 g-5 justify-content-center">
            {data.map(({title, svgName}) => (
              <Col key={svgName} lg={3} xl={4} className="ms-md-5 ms-lg-0">
                <ImageWithText
                  title={title}
                  className="gap-4 px-lg-3"
                  img={getSvgIcon(svgName)}
                />
              </Col>
            ))}
          </Row>

          <p className="d-none d-xl-block">
            These disruptions to family life are made worse when siblings pass
            the disease to one another.
          </p>
          <p className="d-none d-xl-block mt-4">
            *Parents of children who had experienced chickenpox
          </p>
        </Col>

        <Col
          xl={5}
          className="d-flex flex-column jusify-content-center ps-lg-5"
        >
          <div className="d-flex jusify-content-start justify-content-sm-center mb-5 mb-xl-0 position-relative">
            <StaticImage
              src="./img/lasting-impact.png"
              alt="Child and father taking her temperature"
              transformOptions={{fit: 'contain'}}
              width={450}
            />

            <TextInCircle fontSize={1}>
              <p className="text-center">
                Parents* miss on average 4 days of work per child with
                chickenpox
              </p>
            </TextInCircle>
          </div>

          <p className="d-xl-none">
            These disruptions to family life are made worse when siblings pass
            the disease to one another.
          </p>
          <p className="mt-4 d-xl-none">
            *Parents of children who had experienced chickenpox
          </p>
        </Col>
      </Row>
    </Section>
  )
}

export default LastingImpact

const data = [
  {title: 'Scarring', svgName: 'scar'},
  {title: 'Missed holidays & events', svgName: 'plane'},
  {title: 'Time off work', svgName: 'calendar'},
]
